module.exports = __webpack_public_path__ + "media/assets/ChevronLeft-6eb1b87de8dbd08d47a091d79b29c6ec.svg";